// extracted by mini-css-extract-plugin
export default {"content":"SlickSlider_content__MkDxn","ch_img":"SlickSlider_ch_img__zUAGR","childd":"SlickSlider_childd__ADk39","child_text":"SlickSlider_child_text__0jJZ9"};